module.exports = __webpack_public_path__ + "img/453d59d.png";